/**
 * THE NOC WALL's rules (Hamzah, 2026-10-20, the telecom/NOC redesign): which sites it shows, in what
 * order, and how long each stays. Pure, so the rotation is tested without a timer.
 *
 * Every site of the organisation that is not a generation archetype (archetype decides, never a site's
 * name: `isGenerationArchetype`), starting from the one the header has selected, each for `ROTATE_MS`.
 * One site does not rotate.
 */
import { isGenerationArchetype } from '@/lib/plant-views';

/** Long enough to read the strip and the first alarms across a room; short enough to come round again. */
export const ROTATE_MS = 20_000;

export function wallSites<T extends { id: string; archetype: string }>(sites: readonly T[], selectedId: string | null): T[] {
  const shown = sites.filter((s) => !isGenerationArchetype(s.archetype));
  const at = shown.findIndex((s) => s.id === selectedId);
  return at <= 0 ? shown : [...shown.slice(at), ...shown.slice(0, at)];
}

export function nextSite(index: number, count: number): number {
  return count <= 1 ? 0 : (index + 1) % count;
}
